import axios from 'axios'
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import routes from './routes'
// import notifService from '../services/notifService'

Vue.use(VueRouter)

Vue.router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
  },
  routes
})

Vue.router.beforeEach((to, _from, next) => {
  if (to.name == 'home') {
    store.commit('dashboard/resetAdv')
  }

  // check auth
  if (to.matched.some(record => record.meta.auth)) {
    // get status from store
    if (store.state.auth.loggedIn == false) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.MIX_URL

// axios.interceptors.response.use(
//   function(response) { return response},
//   function(error) {
//     // handle error
//     if (error.response) {
//       notifService.notif('apiRes', error.response.data.message, 'error')
//     }
//   })

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('cms')

      window.location = '/login'
    }

    return Promise.reject(error)
  }
)

export default Vue.router
